/**
 * Dedicated "new sign-ups are paused" screen. The OIDC callback redirects a turned-away visitor
 * here (`/?signups_closed=1`) — a Google account that has never been here while sign-ups are on
 * hold. Deliberately its OWN full-screen notice (not woven into the landing) with a single way
 * back, so the visitor can't miss it. Red-accented, but the copy stays reassuring: they did
 * nothing wrong. One button → back to the landing (a plain link to "/" clears the flag).
 */
export function SignupsPaused() {
  return (
    <div className="gate">
      <div className="gate-card alert" role="alert">
        <div className="brand big">Amendie</div>
        <h2 className="gate-title">New sign-ups are paused</h2>
        <p className="muted">
          We're not taking new accounts right now — nothing is wrong with yours. If you already
          have an account, head back and sign in; everything works as usual. New here? Leave your email
          and we'll reach out when access opens.
        </p>
        <div className="row-gap" style={{ justifyContent: "center", marginTop: "var(--sp4)" }}>
          <a className="btn lg" href="/request-access">
            Request access
          </a>
          <a className="btn ghost lg" href="/">
            Back to home
          </a>
        </div>
      </div>
    </div>
  );
}
